import React from 'react';
import { Menu } from 'lucide-react';
import { LOGO_URL } from '../data/api';

const GOLD_LINE = 'rgba(212,168,83,0.58)';

const NAVBAR_BG =
  'https://customer-assets.emergentagent.com/job_96f73dc0-b292-41dd-a366-8b41de2ebdcc/artifacts/qbh0ts7b_Nav%20bar2%20cv80.jpg';

const Navbar = ({ onMenuToggle }) => (
  <div data-testid="navbar" style={{
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
    height: 64,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: '0 16px',
    backgroundImage: `url('${NAVBAR_BG}')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    borderBottom: '1px solid rgba(212,168,83,0.92)',
    boxShadow: '0 1px 0 rgba(212,168,83,0.08), 0 2px 12px rgba(0,0,0,0.28)',
    boxSizing: 'border-box',
  }}>
    {/* Logo — left, vertically centered */}
    <div style={{ width: 48, height: 48, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <img
        src="https://customer-assets.emergentagent.com/job_49133e57-f6cd-4b7b-9084-054c1edd8062/artifacts/zwo57vtg_OG%20Logo.png"
        alt="CV80"
        style={{ width: 48, height: 48, objectFit: 'contain' }}
      />
    </div>

    {/* Hamburger — right */}
    <button
      data-testid="menu-toggle-btn"
      onClick={onMenuToggle}
      style={{
        width: 40, height: 40,
        background: 'none', border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 0,
      }}
    >
      <Menu size={22} color="rgba(212,168,83,0.85)" />
    </button>
  </div>
);

export default Navbar;
